const service = [
  {
    id: 1,
    headtag: "Ask a Question",
    paratag:
      "Ask a question will not vague statements but it will need to be a precise question. Eg: 'When is a good time for my knee surgery?",
    cost: "$5.00",
    imageUrl:
      "https://images.unsplash.com/photo-1515942661900-94b3d1972591?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 2,
    headtag: "Astro Predictions for an Hour",
    paratag:
      "It contains information about you as a person. Discussion about different areas of life, chat about the past, present and future …",
    cost: "$50.00",
    imageUrl:
      "https://images.unsplash.com/photo-1515942661900-94b3d1972591?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 3,
    headtag: "Remedies",
    paratag:
      "Initial rundown of issues that are currently running with advice on possible remedies to overcome the current Issues.",
    cost: "$20.00",
    imageUrl:
      "https://images.unsplash.com/photo-1515942661900-94b3d1972591?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 4,
    headtag: "Fulfilment of Remedies with Rituals",
    paratag: "Spiritual rituals needs to be performed as part of remedy.",
    cost: "$80.00",
    imageUrl:
      "https://images.unsplash.com/photo-1515942661900-94b3d1972591?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

export default service